import React from 'react'
import PropTypes from 'prop-types'
import {loadReCaptcha, ReCaptcha} from 'recaptcha-v3-react'

import debounce from 'lodash.debounce'
import InputMask from 'react-input-mask'
import {Spin} from 'antd'
import {withFormsy} from 'formsy-react'

import {Form as _Form, Input as _Input, Checkbox as _Checkbox} from 'formsy-react-components'
import {Http, getEnvironment} from '../../'
import {Button} from './Elements'


export class Form extends React.Component {
    static contextTypes = {
        environment: PropTypes.object
    }

    state = {
        valid: true,
        captchaSitekey: null,
        gRecaptchaResponse: ''
    }

    componentWillMount() {
        if (this.props.captcha) {
            this.onRenderCaptcha()
        }
    }

    onRenderCaptcha = () => {
        const {GOOGLE_CAPTCHA_SITE_KEY} = getEnvironment()
        loadReCaptcha({
            key: GOOGLE_CAPTCHA_SITE_KEY,
            id: 'captchaId'
        })

        this.setState({captchaSitekey: GOOGLE_CAPTCHA_SITE_KEY})
    }

    handleVerifyCaptcha = (token) => {
        Http.setCatchaToken(token)
    }

    handleSubmit = (data, form) => {
        this.props.onSubmit(data, form)

        if (this.props.captcha) {
            this.refs.recaptcha.execute()
        }
    }


    onValid = () => this.setState({valid: true})
    onInvalid = () => this.setState({valid: false})

    render() {
        const {GOOGLE_CAPTCHA_SITE_KEY} = getEnvironment()
        const {csrfToken} = this.context.environment
        const {
            children, className, label,
            disabled, inline, csrf, captcha,
            loading, repeat, onSubmit, ...rest
        } = this.props

        const valid = this.state.valid && !disabled

        return (
            <_Form
                {...rest}
                onValid={this.onValid}
                onInvalid={this.onInvalid}
                onValidSubmit={this.handleSubmit}
                className={`${!inline ? 'auth__form' : ''} ${className || ''}`}
            >

            {children}

            {(csrf && csrfToken) &&
                <input type="hidden" name="_csrf" value={csrfToken||''} />
            }

            {captcha &&
                <ReCaptcha
                    ref='recaptcha'
                    sitekey={GOOGLE_CAPTCHA_SITE_KEY}
                    action='restore_secret'
                    verifyCallback={this.handleVerifyCaptcha}
                />
            }

            <div className="auth__form-field">
                <Spin spinning={loading || false}
                    wrapperClassName='auth__form-preloader'>

                    <Button type="submit"
                        value={label} disabled={!valid} />
                </Spin>
            </div>
            </_Form>
        );
    }
}

export const Label = ({title, type, hint, error, children}) => (
  <div className={`auth__form-field auth__form-field--${type} ${error && error.length > 0 && 'error'}`}>
    <div className="auth__form-label--right">{hint && (hint() || '')}</div>
    <div className="auth__form-label">{title}</div>

    {children}
  </div>
)

export const Input = ({type, name, ...rest}) => {
  switch (type) {
    case 'hidden':
      return (<_Input type='hidden' name={name} {...rest} />);

    case 'credential':
      return (<CredentialInput {...rest} type={type} name={name}
                              validations="isExistyEmailOrPhone"
                              className={`auth__form-input auth__form-input--${type || ''}`} />);

    case 'password':
      return (<PasswordInput {...rest} type={type} name={name}
                              className={`auth__form-input auth__form-input--${type || ''}`} />);

    case 'phone':
      return (<MaskInput {...rest} type={type} name={name}
                         mask="+38(099) 999-99-99" maskChar="_"
                         className={`auth__form-input auth__form-input--${type || ''}`} />);

    case 'code':
      return (<MaskInput {...rest} type={type} name={name}
                         mask="999999" maskChar=""
                         className={`auth__form-input auth__form-input--${type || ''}`} />);

    default:
      return (<DefaultInput {...rest} name={name}
                            validations="isExisty"
                            className={`auth__form-input auth__form-input--${type || ''}`} />);
  }
};


class TextInput extends React.Component {
  state = { value: null }

  changeDebounced = debounce(
    this.props.setValue, 500
  );

  getErrorMessage = () => {
    const pristine = this.props.isPristine();

    return (pristine == false) ?
      this.props.getErrorMessage() : null;
  }

  onChange = (ev) => {
    const { value } = ev.currentTarget;
    this.changeDebounced(value);
    this.setState({value});
  }

  render() {
    const { title, type, hint } = this.props;
    const { value } = this.state;

    const error = this.getErrorMessage();

    return (
      <Label type={type} title={title} error={error} hint={hint}>
        {this.renderControl()}

        <span className="auth__error">{ error }</span>
      </Label>
    );
  }
};

const DefaultInput = withFormsy(
  class extends TextInput {
    renderControl = () => {
      const { className, name, tabIndex, autoFocus } = this.props;
      const { value } = this.state;

      return (
        <input type="text" className={className}
               name={name} value={value||''} tabIndex={tabIndex}
               autoFocus={autoFocus} onChange={this.onChange} />
      );
    }
  }
);

const CredentialInput = withFormsy(
  class extends TextInput {
    renderControl = () => {
      const { className, name, tabIndex, autoFocus } = this.props;
      const { value } = this.state;

      return (
        <input type="text" className={className}
               name={name} value={value||''} tabIndex={tabIndex}
               autoFocus={autoFocus} onChange={this.onChange} />
      );
    }
  }
);

const PasswordInput = withFormsy(
  class extends TextInput {

    onToggleShow = () => {
      this.setState({isVisible: !this.state.isVisible});
    }

    renderControl = () => {
      const { className, name, tabIndex } = this.props;
      const { value, isVisible } = this.state;

      const eyeClassName = isVisible ? 'off' : '';
      const inputType = isVisible ? 'text' : 'password';

      return (
        <React.Fragment>
          <input type={inputType} className={className}
                 name={name} value={value||''}
                 tabIndex={tabIndex} onChange={this.onChange} />

           <a className="auth__show-pass is-clickable" onClick={this.onToggleShow}>
             <i className={`icon_eye ${eyeClassName}`} />
           </a>
        </React.Fragment>
      );
    }
  }
);

const MaskInput = withFormsy(
  class extends TextInput {
    renderControl() {
      const { className, name, mask, maskChar } = this.props;
      const { value } = this.state;

      return (
        <InputMask type="text" name={name} className={className}
                   mask={mask} maskChar={maskChar} value={value||''}
                   onChange={this.onChange} />
      );
    }
  }
);


export const Checkbox = ({ name, children, ...rest }) => (
  <div className="auth__form-field">
    <label htmlFor={name}>
      <_Checkbox {...rest} id={name} name={name}
                 className="auth__checkbox" layout="elementOnly" />

      {children}
    </label>
  </div>
);
